import { Pipe, PipeTransform } from "@angular/core";
import { pmiPlanStatus } from '../interfaces/pmi/plan.entity';
import { getPmiStatusColor } from '../utils/functions';

@Pipe({
	name: 'statuscolor'
})
export class StatusColorPipe implements PipeTransform {
	transform(status: pmiPlanStatus): string {
		return getPmiStatusColor(status);
	}
}